"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _resourceDatabaseManagement = require("@/api/resourceDatabaseManagement/resourceDatabaseManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { resourceList, applicationTypeUpdate, applicationTypeDelete} from "@/api/backmen/backMen";
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "课程名称",
        type: "input",
        model: "queryValue",
        placeholder: "名称"
      }, {
        label: "项目级别",
        type: "select",
        model: "projectLevel",
        placeholder: "项目级别",
        options: [{
          name: "国家级",
          value: "国家级"
        }, {
          name: "省级",
          value: "省级"
        }, {
          name: "校级",
          value: "校级"
        }]
      }
      // {
      //   label: "资源库类型",
      //   type: "select",
      //   model: "resourceLibraryType",
      //   placeholder: "资源库类型",
      //   options: []
      // },
      // {
      //   label: "课程状态",
      //   type: "select",
      //   model: "isPut",
      //   placeholder: "课程状态",
      //   options:  [
      //               {
      //                   name: "已下架",
      //                   value: 0,
      //               },
      //               {
      //                   name: "已上架",
      //                   value: 1,
      //               },
      //           ],
      // },
      ],
      modelData: {
        queryValue: "",
        projectLevel: "",
        isPut: "",
        resourceLibraryType: ""
      },
      defaultColumn: [{
        name: "课程名称",
        prop: "name",
        isShow: true,
        width: "100"
      }, {
        name: "课程封面",
        prop: "previewPic",
        isShow: true,
        width: "100",
        isImg: true,
        linkColumn: "previewPic"
        // timeFormat: "dateYMD"
      },
      // {
      //   name: "主持教师",
      //   prop: "presidedTeacher",
      //   isShow: true,
      //   width: "100",
      //   // timeFormat: "dateYMD"
      // },
      // {
      //   name: "学习人数",
      //   prop: "userCount",
      //   isShow: true,
      //   width: "100",
      //   // timeFormat: "dateYMD"
      // },
      {
        name: "学校",
        prop: "emceeCompanyname",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "专业大类",
        prop: "majorId",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      },
      // {
      //   name: "免登录链接",
      //   prop: "freeLoginLink",
      //   isShow: true,
      //   width: "100",
      //   // timeFormat: "dateYMD"
      // },
      {
        name: "课程链接",
        prop: "link",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "所属平台",
        prop: "origin",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "数据来源",
        prop: "dataSource",
        isShow: true,
        width: "100",
        isFormats: true
        // timeFormat: "dateYMD"
      }, {
        name: "项目级别",
        prop: "majorLevel",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "产业分类",
        prop: "industry",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }, {
        name: "排序",
        prop: "sort",
        isShow: true,
        width: "100"
        // timeFormat: "dateYMD"
      }
      // {
      //   name: "课程状态",
      //   prop: "onState",
      //   isShow: true,
      //   width: "100",
      //   isFormats: true,
      //   // timeFormat: "dateYMD"
      // }
      ],
      minWidth: 200,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        onState: [{
          name: "已上架",
          value: 1
        }, {
          name: "已下架",
          value: 0
        }],
        dataSource: [{
          name: "国家平台",
          value: 1
        }, {
          name: "省平台",
          value: 2
        }, {
          name: "校级平台",
          value: 3
        }]
      },
      sort: {
        prop: "",
        order: ""
      },
      queryValue: "",
      projectLevel: "",
      isPut: "",
      resourceLibraryType: "",
      checkBoxs: [],
      funBtns: [
      // {
      //   size: "small",
      //   click: "morePut",
      //   name: "批量上架",
      //   type: "success"
      // },
      // {
      //   size: "small",
      //   click: "moreNoPut",
      //   name: "批量下架",
      //   type: "warning"
      // },
      {
        size: "small",
        click: "add",
        name: "新增",
        type: "primary"
      }
      // {
      //   size: "small",
      //   click: "deleteById",
      //   name: "批量删除",
      //   type: "danger"
      // },
      ],
      options: [{
        name: "上架",
        class: "edit",
        option: "toPut",
        span: 3,
        isFuntion: true,
        optionFun: "putnaniu"
      }, {
        name: "下架",
        class: "edit",
        option: "toPut",
        span: 3,
        isFuntion: true,
        optionFun: "noputnaniu"
      }, {
        name: "编辑",
        class: "edit",
        option: "edit",
        span: 3,
        isFuntion: true,
        optionFun: "noEditBtn"
      }, {
        name: "删除",
        class: "delet",
        option: "deleteById",
        span: 3,
        isFuntion: true,
        optionFun: "noEditBtn"
      }, {
        name: "置顶",
        class: "edit",
        option: "toTop",
        span: 3,
        isFuntion: true,
        optionFun: "noEditBtn"
      }],
      isput: {
        ids: [],
        onState: 0
      }
    };
  },
  methods: {
    morePut: function morePut() {
      this.isput.ids = this.checkBoxs;
      this.isput.onState = 1;
      this.put();
    },
    moreNoPut: function moreNoPut() {
      this.isput.ids = this.checkBoxs;
      this.isput.onState = 0;
      this.put();
    },
    toPut: function toPut(e) {
      this.isput.ids.push(e.id);
      e.isPut ? this.isput.onState = 0 : this.isput.onState = 1;
      this.put();
    },
    put: function put() {
      var _this = this;
      (0, _resourceDatabaseManagement.resourcePut)(this.isput).then(function (res) {
        if (res.code == 2000) {
          _this.$message.success(res.msg);
          _this.getList();
        }
      });
    },
    //上架按钮显示判断
    putnaniu: function putnaniu(row, callback) {
      if (row.isPut == 0) {
        callback(true);
      } else {
        callback(false);
      }
    },
    noputnaniu: function noputnaniu(row, callback) {
      if (row.isPut == 1) {
        callback(true);
      } else {
        callback(false);
      }
    },
    noEditBtn: function noEditBtn(row, callback) {
      // console.log('bianji',row)
      if (row.newSource != 1) {
        callback(true);
      } else {
        callback(false);
      }
    },
    // 新增
    add: function add() {
      this.$router.push("/resourceManagement/resourceDatabaseManagementAdd");
    },
    // 编辑
    edit: function edit(e) {
      console.log("e", e);
      this.$router.push({
        path: "/resourceManagement/resourceDatabaseManagementAdd",
        query: {
          id: e.id
        }
      });
    },
    toTop: function toTop(e) {
      var _this2 = this;
      console.log(e, 'toTop');
      this.$confirm("确认置顶吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _resourceDatabaseManagement.placedTop)({
          id: e.id
        }).then(function () {
          _this2.getList();
          _this2.$message.success("置顶成功。");
        });
      }).catch(function () {
        _this2.$message.info("取消置顶。");
      });
    },
    // 模糊搜索新闻分类
    search: function search(val) {
      this.queryValue = val.queryValue;
      this.projectLevel = val.projectLevel;
      this.isPut = val.isPut;
      this.resourceLibraryType = val.resourceLibraryType;
      this.getList();
    },
    // 获取专业资源库管理列表
    getList: function getList() {
      var _this3 = this;
      (0, _resourceDatabaseManagement.resourceList)({
        emceeCompanyname: "",
        ids: [],
        industry: "",
        industryDetail: "",
        keyWord: this.queryValue,
        majorLevel: this.projectLevel,
        name: "",
        onState: this.isPut,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        provinceId: this.$store.getters.provinceId,
        schoolId: ""
      }).then(function (res) {
        var data = res.data;
        console.log("data", data);
        _this3.listData = data.list;
        _this3.totalData = data.total;
        console.log('this.listData', _this3.listData);
      });
    },
    // 删除
    deleteById: function deleteById(row) {
      var _this4 = this;
      // console.log('row',row)
      // let id = [];
      // if (!row && this.checkBoxs.length === 0) {
      //   return this.$message.error("请先勾选数据");
      // } else if (row) {
      //   id.push(row.id);
      // } else if (this.checkBoxs.length > 0) {
      //   id = this.checkBoxs;
      // }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _resourceDatabaseManagement.resourceDelete)({
          id: row.id
        }).then(function () {
          _this4.getList();
          _this4.$message.success("操作成功。");
        });
      }).catch(function () {
        _this4.$message.info("取消删除。");
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this5 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this5.checkBoxs.push(item.id);
      });
    },
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getList();
    }
  },
  created: function created() {
    this.getList();
    var wResourceType = this.$store.getters.wResourceType;
    for (var k in wResourceType) {
      this.queryGroup[2].options.push({
        name: wResourceType[k].name,
        value: wResourceType[k].id
      });
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};